import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { UiSelectOption } from './ui-select.types';
import { UiLabelTranslatePipe } from '../ui-label-translate.pipe';

@Component({
  selector: 'ui-select',
  standalone: true,
  imports: [UiLabelTranslatePipe],
  templateUrl: './ui-select.component.html',
  styleUrl: './ui-select.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiSelectComponent {
  readonly label = input('');
  readonly id = input('');
  readonly value = input<string>('');
  readonly values = input<string[]>([]);
  readonly placeholder = input('Select option');
  readonly options = input<UiSelectOption[]>([]);
  readonly disabled = input(false);
  readonly required = input(false);
  readonly multiple = input(false);
  readonly error = input('');
  readonly hint = input('');
  readonly valueChange = output<string>();
  readonly valuesChange = output<string[]>();

  onValueChange(value: string): void {
    this.valueChange.emit(value);
  }

  onMultiValueChange(options: HTMLCollectionOf<HTMLOptionElement>): void {
    const selected: string[] = [];

    for (const option of Array.from(options)) {
      if (option.selected) {
        selected.push(option.value);
      }
    }

    this.valuesChange.emit(selected);
  }
}
